import { enumToOptions } from '@app/shared/helpers';
import { MipEvent } from '@app/shared/models/contracts/enums/shared-enums';

export const MIP_EVENT_OPTIONS = enumToOptions(MipEvent, undefined, true);
